/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentOutWithUser
 */
export interface CommentOutWithUser {
    /**
     * 
     * @type {string}
     * @memberof CommentOutWithUser
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof CommentOutWithUser
     */
    comment: string;
    /**
     * 
     * @type {number}
     * @memberof CommentOutWithUser
     */
    commentId: number;
    /**
     * 
     * @type {Date}
     * @memberof CommentOutWithUser
     */
    modificationDate: Date;
}

export function CommentOutWithUserFromJSON(json: any): CommentOutWithUser {
    return CommentOutWithUserFromJSONTyped(json, false);
}

export function CommentOutWithUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentOutWithUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'comment': json['comment'],
        'commentId': json['commentId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function CommentOutWithUserToJSON(value?: CommentOutWithUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'comment': value.comment,
        'commentId': value.commentId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


